export const CONSTANTS = {
  ADDONS: {
    GOLF_COVER: 'golf_cover',
    WINTER_SPORTS: 'winter_sports',
    CRUISE_COVER: 'cruise_cover',
    GADGET_COVER: 'gadget_cover',
    EXCESS_WAIVER: 'excess_waiver',
    ENHANCED_TRIP_DISRUPTION: 'enhanced_trip_disruption',
  }
}
